import { render, staticRenderFns } from "./SendTemplateModal.vue?vue&type=template&id=be45064c&scoped=true"
import script from "./SendTemplateModal.vue?vue&type=script&lang=js"
export * from "./SendTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./SendTemplateModal.vue?vue&type=style&index=0&id=be45064c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be45064c",
  null
  
)

export default component.exports